export enum PhotoJobTypes {
    FIXED = 'FIXED',
    FLEXIBE = 'FLEXIBLE',
}
  
export type AvailablePhotoJobTypesResponse = {
    availableTypes: PhotoJobTypes[];
};
